import { Modal, Spin } from 'antd'
import Styles from "../css/payWithQuickbucks.module.scss";
import { LoadingOutlined } from '@ant-design/icons';


const PayWithQuickbucksProgress = (props:any) => {  
    return ( 
        <div>
            <Modal title="Basic Modal" destroyOnClose={true} centered width={400} open={props.isModalOpen} onOk={props.handleOk} className={Styles.customModal}>
                <div className={Styles.modalContentVerification}>
                   <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}><Spin indicator={<LoadingOutlined  style={{ fontSize: 50,color:'black' }} spin />} /></div>
                   <div style={{textAlign:'center'}} className={Styles.title}>Processing loan request</div>
                   <div style={{textAlign:'center',whiteSpace:'pre-line'}} className={Styles.descThree}>Please wait while your loan request is processing</div>
               </div>
            </Modal>   
        </div>
     );
}
 
export default PayWithQuickbucksProgress;